export interface FetchProps {
  isInitial: boolean
  isPending: boolean
  isComplete: boolean
  hasFailed: boolean
}

export type RequestStatus = 'initial' | 'success' | 'error' | 'pending'

export interface RequestStatuses {
  INITIAL: 'initial'
  SUCCESS: 'success'
  ERROR: 'error'
  PENDING: 'pending'
}

const requestStatuses: RequestStatuses = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  ERROR: 'error',
  PENDING: 'pending',
}

export const getRequestStatus = (status: RequestStatus | string): FetchProps => ({
  isInitial: status === requestStatuses.INITIAL,
  isPending: status === requestStatuses.PENDING,
  isComplete: status === requestStatuses.SUCCESS,
  hasFailed: status === requestStatuses.ERROR,
})

export default requestStatuses
